import React, { useState } from "react";
import { connect } from "react-redux";
import { FormattedMessage, injectIntl } from "react-intl";
import * as auth from "../_redux/authRedux";
import _ from 'lodash'
import { useDispatch, } from "react-redux";
import { actionLogin } from '../../../../redux/auth/actions'
import { Input, Form } from 'antd';
import Button from '../../../../components/CustomButton'
import { validateEmailWithoutSpecial } from "../../../lib/common"
import * as TYPE from "../../../lib/contrant";

const formRef = React.createRef()
function Login(props) {

  const { history } = props;
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();

  const onEnterPress = async (e) => {
    if (e.key === "Enter") {
      await onSubmitDelayed()
    }
  }

  const getFirstPathFromAside = (listUserLoginPermission) => {
    if (listUserLoginPermission.includes(TYPE.QUAN_LY_TRANG_CHU)) {
      return "/dashboard";
    }
    if (listUserLoginPermission.includes(TYPE.QUAN_LY_HOMEPAGE)) {
      return "/banner-homepage";
    }
    if (listUserLoginPermission.includes(TYPE.QUAN_LY_TIN_TUC)) {
      return "/content/list";
    }
    if (listUserLoginPermission.includes(TYPE.QUAN_LY_PAGE)) {
      return "/page_setting/list";
    }
    if (listUserLoginPermission.includes(TYPE.QUAN_LY_POPUP)) {
      return "/page_setting/list";
    }
    if (listUserLoginPermission.includes(TYPE.QUAN_LY_NOTIFY)) {
      return "/notify/config";
    }
    if (listUserLoginPermission.includes(TYPE.QUAN_LY_BANNER)) {
      return "/screen-banner";
    }
    if (listUserLoginPermission.includes(TYPE.QUAN_LY_TRANG_DOI_TAC)) {
      return "/partner/list";
    }
    if (listUserLoginPermission.includes(TYPE.QUAN_LY_CAU_HINH_MARKETING)) {
      return "/campaign-config";
    }
    if (listUserLoginPermission.includes(TYPE.LICH_SU_VOICEBOT)) {
      return "/voice-bot";
    }
    if (listUserLoginPermission.includes(TYPE.THUONG_NGUOI_DUNG)) {
      return "/commission_cms/get-list";
    }
    if (listUserLoginPermission.includes(TYPE.QUAN_LY_NGUOI_DUNG)) {
      return "/user/list-user";
    }
    if (listUserLoginPermission.includes(TYPE.QUAN_LY_GIAO_DICH)) {
      return "/transaction/money/list";
    }
    if (listUserLoginPermission.includes(TYPE.QUAN_LY_DOI_SOAT_GIAO_DICH)) {
      return "/verify/verify-transaction";
    }
    if (listUserLoginPermission.includes(TYPE.QUAN_LY_DON_HANG)) {
      return "/order/list";
    }
    if (listUserLoginPermission.includes(TYPE.QUAN_LY_AGENCY)) {
      return "/agency/list";
    }
    if (listUserLoginPermission.includes(TYPE.QUAN_LY_SAN_PHAM)) {
      return "/product/list";
    }
    if (listUserLoginPermission.includes(TYPE.QUAN_LY_DS_MASTER)) {
      return "/system-account";
    }
    if (listUserLoginPermission.includes(TYPE.QUAN_LY_VANG)) {
      return "/assets-management";
    }
    if (listUserLoginPermission.includes(TYPE.QUAN_LY_TAI_KHOAN)) {
      return "/master/history/cash_flow";
    }
    if (listUserLoginPermission.includes(TYPE.QUAN_LY_DS_GIAO_DICH)) {
      return "/system-change-balance";
    }
    if (listUserLoginPermission.includes(TYPE.QUAN_LY_TIEN_VANG_KHOA)) {
      return "/list-coin-lock";
    }
    if (listUserLoginPermission.includes(TYPE.QUAN_LY_CHO_VAY)) {
      return "/loan/list";
    }
    if (listUserLoginPermission.includes(TYPE.QUAN_LY_DAU_TU)) {
      return "/accumulation/list";
    }
    if (listUserLoginPermission.includes(TYPE.QUAN_LY_NFC)) {
      return "/nfc/list";
    }
    if (listUserLoginPermission.includes(TYPE.QUAN_LY_CAU_HINH)) {
      return "/system-config";
    }
    if (listUserLoginPermission.includes(TYPE.SYSTEM_MANAGEMENT)) {
      return "/root-account";
    }
    if (listUserLoginPermission.includes(TYPE.THUONG_KYC_DAI_LY)) {
      return "/agency-bonus";
    }
    if (listUserLoginPermission.includes(TYPE.SYSTEM_MANAGEMENT)) {
      return "/admin/list-user";
    }
    if (listUserLoginPermission.includes(TYPE.QUAN_LY_NGAN_HANG)) {
      return "/bank/list";
    }
    if (listUserLoginPermission.includes(TYPE.QUAN_LY_GIA_VANG)) {
      return "/gold_price/group";
    }
    if (listUserLoginPermission.includes(TYPE.QUAN_LY_GIA_VANG)) {
      return "/rate_mana/reference";
    }
    if (listUserLoginPermission.includes(TYPE.QUAN_LY_THONG_KE)) {
      return "/statistical/user";
    }
    if (listUserLoginPermission.includes(TYPE.QUAN_LY_MERCHANT)) {
      return "/merchant";
    }

    return "/dashboard";
  };

  const onSubmitDelayed = _.debounce(() => onSubmit(), 100)
  const onSubmit = async () => {
    await formRef.current.validateFields();
    setLoading(true)
    const { email, password } = formRef.current.getFieldsValue()

    const dataSubmit = {
      email: email,
      password: password
    }

    const res = await dispatch(actionLogin(dataSubmit))

    if (res) {
      const firstPath = getFirstPathFromAside(res?.listPermission)

      return history.push(firstPath)
    }

    setLoading(false)
  }

  return (
    <div className="login-form login-signin" id="kt_login_signin_form">
      {/* begin::Head */}
      <div className="text-center mb-10 mb-lg-20">
        <h3 className="font-size-h1" style={{ color: '#D6B970' }}>
          <FormattedMessage id="AUTH.LOGIN.TITLE" />
        </h3>
        <p className="text-muted font-weight-bold">
          Nhập email và mật khẩu
        </p>
      </div>
      {/* end::Head */}

      {/*begin::Form*/}
      <Form
        name="customForm"
        ref={formRef}
        className="form fv-plugins-bootstrap fv-plugins-framework"
        initialValues={{
          email: "",
          password: "",
        }}
        onSubmit={onSubmit}
      >
        {/* <div className="mb-10 alert alert-custom alert-light-info alert-dismissible">
          <div className="alert-text row-center fs--16 lh--24">
            <strong>Chào mừng trở lại 100MAN!</strong>
          </div>
        </div> */}

        <div className="form-group fv-plugins-icon-container">
          <Form.Item
            type="text"
            name="email"
            rules={[
              {
                validator: (_, value) => {
                  if (!value || value.trim() === "") {
                    return Promise.reject("Mời bạn nhập Email!")
                  } else if (value && !validateEmailWithoutSpecial(value.trim())) {
                    return Promise.reject("Email không đúng định dạng!")
                  } else {
                    return Promise.resolve()
                  }
                }
              }
            ]}
          >
            <Input
              className="customInput"
              placeholder="Email"
              // prefix={<img src="images/email_24px.svg" alt="" />}
              onKeyPress={e => onEnterPress(e)}
              style={{ background: '#282828', color: '#b8bbbb' }}
            />
          </Form.Item>
        </div>
        <div className="form-group fv-plugins-icon-container mt--13">
          <Form.Item
            name="password"
            rules={[
              {
                validator: (_, value) => {
                  if (!value || value.trim() === "") {
                    return Promise.reject("Mời bạn nhập Password!")
                  } else {
                    return Promise.resolve()
                  }
                }
              }
            ]}
          >
            <Input
              type="password"
              className="customInput"
              placeholder="Password"
              // prefix={<img src="images/lock_24px 2.svg" alt="" />}
              onKeyPress={e => onEnterPress(e)}
              style={{ background: '#282828', color: '#b8bbbb' }}
            />
          </Form.Item>
        </div>
        <div className="form-group justify-content-between align-items-center" style={{ textAlign: 'center', marginTop: 20 }}>
          <Button
            type='submit'
            className="width100"
            loading={loading}
            title="Đăng nhập"
            btnColor="#ffffff"
            btnBgColor="#c96f00"
            btnHoverBackground="#df800c"
            onClick={onSubmitDelayed}
            style={{ border: 'none' }}
          />
        </div>
      </Form>
      {/*end::Form*/}
    </div>
  );
}

export default injectIntl(connect(null, auth.actions)(Login));
